export default __webpack_public_path__ + "static/media/chall-logo-mobile-16dic25.dfe148dc.png";